import { useMemo } from 'react'
import { P, Wrapper } from '@farewill/ui'
import type { DocumentWithAttributes } from 'lib/models/document'
import { SavedDocuments } from './saved-documents'
import { ReviewDocuments } from './review-documents'

export const DocumentList = ({
  documents,
  isLoading,
}: {
  documents: DocumentWithAttributes[]
  isLoading: boolean
}) => {
  const savedDocuments = useMemo(() => {
    return documents.filter(
      (document) => document.attributes.status === 'published'
    )
  }, [documents])

  const reviewDocuments = useMemo(() => {
    return documents.filter(
      (document) => document.attributes.status === 'review'
    )
  }, [documents])

  if (isLoading) {
    return (
      <Wrapper>
        <P>Loading documents...</P>
      </Wrapper>
    )
  }

  return (
    <Wrapper>
      <ReviewDocuments reviewDocuments={reviewDocuments} />
      <SavedDocuments savedDocuments={savedDocuments} />
    </Wrapper>
  )
}
